import React from 'react';
import Header from '../components/common/Header';
import Card from '../components/home/card';
import HeroSection from '../components/home/HeroSection';
import Profils from '../components/home/profils';
import Shop from '../components/home/shop';
import { Box } from '@mui/material';

function HomePage() {
  return (
    <Box className="mobile-app-container has-fixed-header" sx={{ bgcolor: '#FFF7E5' }}>
      <Header />
      <HeroSection />
      <Box
        sx={{
          bgcolor: '#FFF7E5',
          justifyContent: 'center',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          rowGap: 3,
        }}
      >
        <Box sx={{ width: '100%', display: { xs: 'flex', md: 'none' }, justifyContent: 'center' }}>
          <Card />
        </Box>
        <Profils />
        <Shop />
      </Box>
    </Box>
  );
}

export default HomePage;
